import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import FanzoneRecommend from '../FanzoneRecommend/FanzoneRecommend';


import './NotInRegion.css';


function NotInRegion(props) {
  console.log(props);

  return (
    <div className="calendar-checkout-container">
      <h1 className="calendar-checkout-title">Thank you for your interest!</h1>
      <p className="calendar-checkout-text">
        Unfortunately at the moment we are not delivering in your area, however we are extending it every day. Once delivery becomes available in your country we will let you know.
        If you have any questions or comments please <a href="/contact">contact us</a>.
      </p>
      <FanzoneRecommend anchorId={props.anchorId} failed={true} />
    </div>
  );
}

// NotInRegion.propTypes = {
// };

export default NotInRegion;
